import { AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import React, { createContext } from 'react';
import UserPool from '../../auth/UserPool';
import { signup, getAuthInfo, getOldUser } from '../../api/methods';

const AuthContext = createContext();

const Auth = (props) => {
  const [auth, setAuth] = React.useState(null);
  const [user, setUser] = React.useState(null);

  const getSession = async () => {
    return await new Promise((resolve, reject) => {
      const user = UserPool.getCurrentUser();
      if (user) {
        user.getSession((err, session) => {
          if (err) {
            reject(err);
          } else {
            resolve(session);
          }
        });
      } else {
        reject(new Error('no user'));
      }
    });
  };

  const authenticate = async (Username, Password) => {
    return await new Promise((resolve, reject) => {
      const user = new CognitoUser({ Username, Pool: UserPool });

      const authDetails = new AuthenticationDetails({ Username, Password });

      console.log(Username, Password);

      user.authenticateUser(authDetails, {
        onSuccess: (data) => {
          console.log('onSuccess', data);
          resolve(data);
        },
        onFailure: (err) => {
          console.log('onFailure', err);
          reject(err);
        },
        newPasswordRequired: (data) => {
          console.log('newPasswordRequired', data);
          delete data.email_verified;
          user.completeNewPasswordChallenge(Password, data, {
            onSuccess: result => {
              resolve(result);
            },
            onFailure: err => {
              alert(err);
              reject(err);
            }
          });
        }
      });
    });
  };

  const getAuth = async () => {
    let session;
    try {
      session = await getSession();
      const jwt = session.idToken.jwtToken;
      return ({
        loggedIn: true,
        jwt
      });
    } catch (err) {
      return ({
        loggedIn: false,
        jwt: null
      });
    }
  };

  const login = async (email, password) => {
    let accessInfo;
    try {
      accessInfo = await authenticate(email, password);
    } catch (error) {
      try {
        const oldUser = await getOldUser(email);
        console.log('yeah', oldUser);
        await signup({ firstName: 'Felix', lastName: 'Medicus', ...oldUser, email, password, passwordRepeat: password });
        accessInfo = await authenticate(email, password);
      } catch (error) {
        console.log(error);
        throw new Error('Username und Passwort stimmen nicht überein');
      }
    }
    const jwt = accessInfo.idToken.jwtToken;
    const userInfo = await getAuthInfo(jwt);
    setUser(userInfo);
    setAuth({ ...auth, loggedIn: true, jwt });
  };

  const logout = () => {
    const user = UserPool.getCurrentUser();
    if (user) {
      user.signOut();
      setAuth({ loggedIn: false });
    }
  };

  const reloadUser = async () => {
    if (auth.loggedIn) {
      const userInfo = await getAuthInfo(auth.jwt);
      setUser(userInfo);
    }
  };

  const silentLogin = async () => {
    const info = await getAuth();
    setAuth(info);
    const userInfo = await getAuthInfo(info.jwt);
    setUser(userInfo);
  };

  React.useEffect(() => {
    silentLogin();
  }, []);

  return (
    <AuthContext.Provider value={{ auth, user, reloadUser, login, logout, signup, setLoggedIn: () => setAuth({ ...auth, loggedIn: true }) }}>
      {props.children}
    </AuthContext.Provider>
  );
};

export { Auth, AuthContext }
;
